// extracted by mini-css-extract-plugin
export default {"list":"trade-desk_list__54mOL","listResizer":"trade-desk_listResizer__Xt2dQ"};